import styled from 'styled-components';

export const ScreenSizeGuardLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
`;
